import { z } from 'zod'

export const dailyReviewSearchSchema = z.object({
  excludedCategoryIds: z
    .array(z.number().int().nonnegative())
    .transform((ids) => [...new Set(ids)])
    .optional()
    .catch(undefined),
})
